import { FunctionComponent, useContext } from "react";

import { AppContext } from "../../../context/AppContext";
import ScrollableContainer from "../../../layout/scrollable-container";
import Footer from "../../../components/footer";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { ERROR_CODE_500 } from "../../../typings";

import sendError from "../../../utils/sendError";
import { sendSentryError } from "../../../lib/sentry";
import { VectorWrapper } from "../../post-transfer/styles";
import errorVector from "./errorVector.svg";
import { HeadlineMedium } from "../../../components/font";
import { Button, tokens } from "@manifesthhqinc/ui-library";
import Spacing from "../../../layout/spacing";
import { EmailLink, ErrorItem, ErrorItems } from "./styles";

const NetworkErrorPane: FunctionComponent = (props: any) => {
  const { isWebview, parentUrl } = useContext(AppContext);

  const sendErrorHandler = () => {
    const errorId = sendSentryError(props.error);

    sendError(
      {
        errorCode: ERROR_CODE_500,
        errorMessage: `Looks like there is an Network error. ${errorId ? `Error Reference: ${errorId}` : ""}`,
      },
      isWebview,
      parentUrl,
    );
  };
  return (
    <TransitionWrapper>
      <ScrollableContainer name="consent-pane-content">
        <Container>
          <HeadlineMedium $textAlign="center">Oops, we couldn’t load that</HeadlineMedium>
          <Spacing token={tokens.spacing.xs} />
          <p>
            It looks like network settings are blocking us from loading the app. Don’t worry, here are a few things you
            can try:
          </p>
          <Spacing token={tokens.spacing.xs} />
          <ErrorItems>
            <ErrorItem>Turn off your VPN and try again</ErrorItem>
            <ErrorItem>Switch to another device or network</ErrorItem>
            <ErrorItem>Exit the app and restart our app</ErrorItem>
          </ErrorItems>
          <Spacing token={tokens.spacing.xs} />
          <p>
            Still stuck? Contact us for help:{" "}
            <EmailLink href="mailto:support@usemanifest.com">support@usemanifest.com</EmailLink> and we’ll help you
            resolve this.
          </p>
          <VectorWrapper $paddingTop={20}>
            <img src={errorVector} alt="error" height={140} width={140} />
          </VectorWrapper>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={sendErrorHandler} name="exit-manifest" size="large">
          Exit
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default NetworkErrorPane;
